module.exports = __webpack_public_path__ + "static/media/industrialWallPattern.129abd4a.jpg";